import {
    FETCH_WAREHOUSE_DETAIL_SUCCESS,
    REQUEST_ZONES,
    FETCH_ZONES_SUCCESS,
    FETCH_ZONES_FAILURE,
    SELECT_ZONE,
    RESET_CURRENT_ZONE,
    REQUEST_ZONE_DETAIL,
    FETCH_ZONE_DETAIL_SUCCESS,
    FETCH_ZONE_DETAIL_FAILURE,
    REQUEST_CREATING_ZONE,
    CREATE_ZONE_SUCCESS,
    CREATE_ZONE_FAILURE,
    REQUEST_EDITING_ZONE,
    EDIT_ZONE_SUCCESS,
    EDIT_ZONE_FAILURE,
    REQUEST_BINS,
    FETCH_BINS_SUCCESS,
    FETCH_BINS2_SUCCESS,
    FETCH_BINS3_SUCCESS,
    FETCH_BINS_FAILURE,
    RESET_BINS,
    SELECT_BIN,
    RESET_CURRENT_BIN,
    REQUEST_BIN_DETAIL,
    FETCH_BIN_DETAIL_SUCCESS,
    FETCH_BIN_DETAIL_FAILURE,
    REQUEST_CREATING_BIN,
    CREATE_BIN_SUCCESS,
    CREATE_BIN_FAILURE,
    REQUEST_EDITING_BIN,
    EDIT_BIN_SUCCESS,
    EDIT_BIN_FAILURE,
    REQUEST_DELETE_ZONE,
    DELETE_ZONE_SUCCESS,
    DELETE_ZONE_FAILURE,
    REQUEST_DELETE_BIN,
    DELETE_BIN_SUCCESS,
    DELETE_BIN_FAILURE,
    FETCH_LEVELS,
    FETCH_LEVELS_SUCCESS,
    FETCH_LEVELS2_SUCCESS,
    FETCH_LEVELS3_SUCCESS,
    FETCH_LEVELS_ERROR,
    CREATE_BARCODE,
    CREATE_BARCODE_SUCCESS,
    CREATE_BARCODE_FAILURE,
    SELECT_LEVEL,
    REQUEST_EDITING_LEVEL,
    EDITING_LEVEL_SUCCESS,
    EDITING_LEVEL_FAILURE,
    CREATE_LEVEL_FAILURE,
    CREATE_LEVEL_SUCCESS,
    CREATE_LEVEL_REQUEST,
    ATTACH_ZONE_BIN_LEVEL,
    ATTACH_ZONE_BIN_LEVEL_SUCCESS,
    ATTACH_ZONE_BIN_LEVEL_FAILURE,
    REQUEST_DELETE_LEVEL,
    DELETE_LEVEL_SUCCESS,
    DELETE_LEVEL_FAILURE,
} from '../actions/type'

const INITIAL_STATE = {
    all: [],
    currentZone: null,
    currentZoneDetail: null,
    isLoading: false,
    error: null,
    detailIsLoading: false,
    detailError: null,
    isCreating: false,
    createError: null,
    created: false,
    isEditing: false,
    editError: null,
    edited: false,
    bins: [],
    bins2: [],
    bins3: [],
    bin: null,
    level: null,
    currentBin: null,
    currentBinDetail: null,
    binDetailIsLoading: false,
    binDetailError: null,
    binIsCreating: false,
    binCreateError: null,
    createBinSuccess: false,
    binIsEditing: false,
    binEditError: null,
    binEdited: false,
    deleteZone: false,
    deleteZoneSuccess: null,
    deleteZoneFailureError: null,
    deleteBin: false,
    deleteBinSuccess: null,
    deleteBinFailureError: null,
    levels: [],
    levels2: [],
    levels3: [],
    createBarcodeSuccess: null,
    createBarcodeFailureError: null,
    barcode: null,
    zone: null,
    updatedZone: null, 
    updatedBin: null, 
    updatedLevel: null,
    currentLevel: null,
    levelEditError: null,
    levelEditied: null,
    levelCreateError: null,
    createLevelSuccess: false,
    isAttaching: false,
    attachDocumentError: null,
    attachDocumentSuccess: null,
    deleteLevel: null,
    deleteLevelSuccess: null,
    deleteLevelFailureError: null,
};


export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        case FETCH_WAREHOUSE_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, all: action.payload.data.Warehouse_Zone };

        // Zone action handlers
        case REQUEST_ZONES:
            return { ...state, error: null, isLoading: true };
        case FETCH_ZONES_SUCCESS:
            return { ...state, all: action.payload.data, error: null, isLoading: false };
        case FETCH_ZONES_FAILURE:
            const error = action.payload || { message: action.payload.message };
            return { ...state, all: [], error: error, isLoading: false };
        case SELECT_ZONE:
            return { ...state, currentZone: action.payload };
        case RESET_CURRENT_ZONE:
            return { ...state, currentZone: null, currentZoneDetail: null };
        case REQUEST_ZONE_DETAIL:
            return { ...state, detailError: null, detailIsLoading: true };
        case FETCH_ZONE_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentZoneDetail: action.payload.data, detailError: null, detailIsLoading: false, bins: action.payload.data.Warehouse_Bin };
        case FETCH_ZONE_DETAIL_FAILURE:// return error and make loading = false
            const detailError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, all: [], detailError: detailError, detailIsLoading: false };
        case REQUEST_CREATING_ZONE:
            return { ...state, isCreating: true, createError: null, created: false };
        case CREATE_ZONE_SUCCESS:
            return { ...state, zone: action.payload.data, isCreating: false, createError: null, created: true };
        case CREATE_ZONE_FAILURE:
            const createError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, isCreating: false, createError: createError, created: false };
        case REQUEST_EDITING_ZONE:
            return { ...state, isEditing: true, editError: null, edited: false };
        case EDIT_ZONE_SUCCESS:
            return { ...state, updatedZone: action.payload.data, isEditing: false, editError: null, edited: true };
        case EDIT_ZONE_FAILURE:
            const editError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, isEditing: false, editError: editError, edited: false };

        // Bin action handlers
        case REQUEST_BINS:
            return { ...state, binError: null, binIsLoading: true };
        case FETCH_BINS_SUCCESS:
            return { ...state, bins: action.payload.data, binError: null, binIsLoading: false };
        case FETCH_BINS2_SUCCESS:
            return { ...state, bins2: action.payload.data, binError: null, binIsLoading: false };
        case FETCH_BINS3_SUCCESS:
            return { ...state, bins3: action.payload.data, binError: null, binIsLoading: false };
        case FETCH_BINS_FAILURE:
            const binError = action.payload || { message: action.payload.message };
            return { ...state, bins: [], bins2: [], bins3: [], binError, binIsLoading: false };
        case FETCH_LEVELS:
            return { ...state, levelsError: null, fetchLevelsIsLoading: true }
        case FETCH_LEVELS_SUCCESS:
            return { ...state, levels: action.payload.data, levelsError: false, fetchLevelsIsLoading: false }
        case FETCH_LEVELS2_SUCCESS:
            return { ...state, levels2: action.payload.data, levelsError: false, fetchLevelsIsLoading: false }
        case FETCH_LEVELS3_SUCCESS:
            return { ...state, levels3: action.payload.data, levelsError: false, fetchLevelsIsLoading: false }
        case FETCH_LEVELS_ERROR:
            const levelsError = action.payload || { message: action.payload.message };
            return { ...state, levels: [], levelsError, fetchLevelsIsLoading: false };
        case RESET_BINS:
            return { ...state, bins: [], bins2: [], bins3: [], binError: null, binIsLoading: false };
        case SELECT_BIN:
            return { ...state, currentBin: action.payload };
        case RESET_CURRENT_BIN:
            return { ...state, currentBin: null, currentBinDetail: null };
        case REQUEST_BIN_DETAIL:
            return { ...state, binDetailError: null, binDetailIsLoading: true };
        case FETCH_BIN_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentBinDetail: action.payload.data, binDetailError: null, binDetailIsLoading: false };
        case FETCH_BIN_DETAIL_FAILURE:// return error and make loading = false
            const binDetailError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, all: [], binDetailError: binDetailError, binDetailIsLoading: false };
        case REQUEST_CREATING_BIN:
            return { ...state, isCreating: true, binCreateError: null, createBinSuccess: false };
        case CREATE_BIN_SUCCESS:
            return { ...state, bin: action.payload.data, isCreating: false, binCreateError: null, createBinSuccess: true };
        case CREATE_BIN_FAILURE:
            const binCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, isCreating: false, binCreateError: binCreateError, createBinSuccess: false };
        case REQUEST_EDITING_BIN:
            return { ...state, isEditing: true, binEditError: null, binEdited: false };
        case EDIT_BIN_SUCCESS:
            return { ...state, updatedBin: action.payload.data, isEditing: false, binEditError: null, binEdited: true };
        case EDIT_BIN_FAILURE:
            const binEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, isEditing: false, binEditError: binEditError, binEdited: false };
        case REQUEST_DELETE_ZONE:
            return { ...state, deleteZone: true, deleteZoneSuccess: null, deleteZoneFailureError: null };
        case DELETE_ZONE_SUCCESS:
            return { ...state, deleteZone: false, deleteZoneSuccess: true };
        case DELETE_ZONE_FAILURE:
            const deleteZoneFailureError = action.payload.data || { message: action.payload.messge };
            return { ...state, deleteZone: false, deleteZoneFailureError: deleteZoneFailureError };
        case REQUEST_DELETE_BIN:
            return { ...state, deleteBin: true, deleteBinSuccess: null, deleteBinFailureError: null };
        case DELETE_BIN_SUCCESS:
            return { ...state, deleteBin: false, deleteBinSuccess: true };
        case DELETE_BIN_FAILURE:
            const deleteBinFailureError = action.payload.data || { message: action.payload.messge };
            return { ...state, deleteBin: false, deleteBinFailureError: deleteBinFailureError };
        case CREATE_BARCODE: 
            return {...state, isCreating: true, createError: null, created: false}
        case CREATE_BARCODE_SUCCESS:
            return {...state, isCreating: false, createError: null, created: true}
        case CREATE_BARCODE_FAILURE:
            const createBarcodeFailure = action.payload.data || {message: action.payload.message}
            return {...state, isCreating: false, createError: createBarcodeFailure, created: false  }
        case SELECT_LEVEL: 
            return { ...state, currentLevel: action.payload };
        case REQUEST_EDITING_LEVEL:
            return { ...state, isEditing: true, levelEditError: null, levelEditied: false };
        case EDITING_LEVEL_SUCCESS: 
            return {...state, updatedLevel: action.payload.data, isEditing: false, levelEditError: null, levelEditied: true}; 
        case EDITING_LEVEL_FAILURE: 
            const levelEditError = action.payload.data || { message: action.payload.message };
            return {...state, isEditing: false, levelEditError: levelEditError, levelEditied: false}; 
        case CREATE_LEVEL_REQUEST:
            return { ...state, isCreating: true, levelCreateError: null, createLevelSuccess: false };
        case CREATE_LEVEL_SUCCESS:
             return { ...state, level: action.payload.data, isCreating: false, levelCreateError: null,createLevelSuccess: true };
        case CREATE_LEVEL_FAILURE:
            const levelCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, isCreating: false, levelCreateError: levelCreateError, createLevelSuccess: false };
        case ATTACH_ZONE_BIN_LEVEL:
            return {...state, isAttaching: null, attachDocumentError: null, attachDocumentSuccess: null}
        case ATTACH_ZONE_BIN_LEVEL_SUCCESS:
            return {...state, isAttaching: true, attachDocumentError: null, attachDocumentSuccess: true}
        case ATTACH_ZONE_BIN_LEVEL_FAILURE:
            const attachDocumentError = action.payload.data || {message: action.payload.data}
            return {...state, isAttaching: false, attachDocumentError: attachDocumentError, attachDocumentSuccess: false}
        case REQUEST_DELETE_LEVEL:
            return {...state, deleteLevel: true, deleteLevelSuccess: null, deleteLevelFailureError: null}
        case DELETE_LEVEL_SUCCESS:
            return {...state, deleteLevel: false, deleteLevelSuccess: true} 
        case DELETE_LEVEL_FAILURE:
            const deleteLevelFailureError = action.payload.data || {message: action.payload.data};
            return {...state, deleteLevel: false, deleteLevelSuccess: false, deleteLevelFailureError: deleteLevelFailureError}
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/zones_reducer.js